/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import { useState, Suspense, forwardRef, useContext, useEffect } from "react";
import {
	NexcalEmployeeLogo,
	PhcsLogo,
	QuestDiagonosticLogo,
	BrookshireLogo,
	CPLLogo,
	EntiraGreenLogo,
	TeleConnectLogo
} from "../../../../../assets";
import CustomDataGrid from "../../../../shared/customDataGrid/CustomDataGrid";
import { AuthContext } from "../../../../../contexts";
import { maskSSN } from "../../../../../constants/maskSSN";

import { Grid, Paper } from "@mui/material";
import QRCode from "react-qr-code";
import { getLocalIPV4 } from "../../../../../utils/commonFunctions/getLocalIP4";
import { MEMBER_ENV } from "../../../../../config/config";
import encryption from "../../../../../utils/commonFunctions/encryption";

import "./clinicCardPrint.css";

const ClinicCardPrintV2 = forwardRef(({ first_name, last_name, _ssn, group_number }, ref) => {
	// // console.log("first_name", props);
	const [localIP, setLocalIP] = useState("");
	const [urlLink, setUrlLink] = useState("");
	const { member } = useContext(AuthContext);

	// console.log("Member Details55555", member);
	const ssn = maskSSN(_ssn);
	// console.log("_ssn", _ssn);

	useEffect(() => {
		// eslint-disable-next-line arrow-parens
		getLocalIPV4().then((ip) => setLocalIP(ip));
	}, []);

	useEffect(() => {
		const { group_number, date_of_birth, SSN } = member;

		if (member) {
			const prodRedirectionLink = `www.nexcaliber.com/eligibility-check?gn=${group_number}&&qs=${encryption(
				SSN
			)}&&db=${encryption(date_of_birth)}`;

			if (member && (MEMBER_ENV === "PROD" || MEMBER_ENV === "DEV")) setUrlLink(prodRedirectionLink);
		}

		if (member && localIP) {
			const localRedirectionLink = `http:${localIP}:3002/eligibility-check?gn=${group_number}&&qs=${encryption(
				SSN
			)}&&db=${encryption(date_of_birth)}`;

			// const prodRedirectionLink = `www.nexcaliber.com/eligibility-check?gn=${group_number}&&qs=${encryption(
			// 	SSN
			// )}&&db=${encryption(date_of_birth)}`;

			if (member && MEMBER_ENV === "LOCAL") setUrlLink(localRedirectionLink);
			// if (member && (MEMBER_ENV === "PROD" || MEMBER_ENV === "DEV")) setUrlLink(prodRedirectionLink);
		}
	}, [member, localIP]);

	return (
		<div ref={ref}>
			<div className="employee-health-card-container">
				<div className="paper-form-container">
					<Paper className="theme-border-radius employee-print-paper-container" elevation={1}>
						<Grid container className="card-header-container">
							<Grid item xs={3} sm={3} md={3} lg={3} xl={3} className="group-logo">
								<img
									src={BrookshireLogo}
									alt="Brookshire-logo"
									style={{ width: "6rem", height: "6rem", marginTop: 6 }}
								/>
							</Grid>
							<Grid item xs={9} sm={9} md={9} lg={9} xl={9} className="health-card-content">
								<div className="employee-health-card-header">
									<span>BROOKSHIRE BROTHERS</span>
									<span>Clinic Card Program</span>
								</div>
								<div className="employee-health-card-sub-header">
									<span style={{ marginTop: 4 }}>Administrated by Nexcaliber</span>
									<span style={{ marginTop: 1 }}>Group#219</span>
								</div>
								<div className="employee-health-card-sub-header">
									<span>Workplace Wellness with Community Spirit</span>
								</div>
								<div className="employee-health-border" />
							</Grid>
						</Grid>

						<div style={{ display: "flex" }}>
							<div>
								<span
									className="qr-code-container"
									style={{
										position: "relative",
										display: "flex",
										flex: 1,
										marginTop: "1.5rem"
									}}
								>
									<QRCode
										size={256}
										style={{
											height: "5rem",
											padding: "0.4rem",
											maxWidth: "100%",
											width: "100%",
											marginTop: "-2rem"
											// backgroundColor: "red"
										}}
										value={urlLink}
										fgColor="#4e4e4e"
										bgColor="#ffffff"
									/>

									{/* Top-left corner border */}
									<div
										className="corner-border top-left"
										style={{
											position: "absolute",
											top: -30,
											left: 15,
											width: "20px",
											height: "20px",
											borderTop: "2px solid #9c27b0",
											borderLeft: "2px solid #9c27b0"
										}}
									></div>

									{/* Top-right corner border */}
									<div
										className="corner-border top-right"
										style={{
											position: "absolute",
											top: -31,
											right: 15,
											width: "20px",
											height: "20px",
											borderTop: "2px solid #9c27b0",
											borderRight: "2px solid #9c27b0"
										}}
									></div>

									{/* Bottom-left corner border */}
									<div
										className="corner-border bottom-left"
										style={{
											position: "absolute",
											bottom: 1,
											left: 15,
											width: "20px",
											height: "20px",
											borderBottom: "2px solid #9c27b0",
											borderLeft: "2px solid #9c27b0"
										}}
									></div>

									{/* Bottom-right corner border */}
									<div
										className="corner-border bottom-right"
										style={{
											position: "absolute",
											bottom: 1,
											right: 15,
											width: "20px",
											height: "20px",
											borderBottom: "2px solid #9c27b0",
											borderRight: "2px solid #9c27b0"
										}}
									></div>
								</span>
								<div
									style={{
										fontWeight: "700",
										fontSize: "0.65rem",
										width: "8rem",
										textAlign: "center",
										marginRight: "-0.5rem"
									}}
								>
									Scan for eligibility and benefits
								</div>
							</div>
							<Grid container className="employee-card-details-container" sx={{ marginLeft: "1rem" }}>
								<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
									<div className="employee-details-container">
										<span>Employee ID Number:</span>
										<span style={{ marginLeft: "0.2rem" }}>XXX-XX-{ssn}</span>
									</div>
									<div style={{ marginTop: "0.1rem" }}>Please obtain missing digits from patient</div>
									<div className="employee-details-container" style={{ marginTop: "0.3rem" }}>
										<span>Employee Name:</span>
										<span style={{ marginLeft: "0.2rem" }}>
											{member?.last_name.toUpperCase()}, {member?.first_name.toUpperCase()}
										</span>
									</div>
									<div className="employee-details-container top-margin-two">
										Clinic Location: LUFKIN
									</div>

									<div
										className="employee-details-container top-margin"
										style={{ marginTop: "0.5rem" }}
									>
										Contact Clinic at (936) 634-1400
									</div>
								</Grid>
								{/* <Grid item xs={5} sm={5} md={5} lg={5} xl={5} style={{ marginTop: "-2rem" }}>
								<div className="header-logo-container">
									<div className="phcs-logo-container" style={{ marginTop: "1.5rem" }}>
										<img src={EntiraGreenLogo} style={{ width: "7.5rem", height: "2rem" }} />
									</div>
									<div
										className="logo-details employee-details-container"
										style={{ fontSize: "0.5rem", width: "11rem" }}
									>
										Workplace Wellness with Community Spirit
									</div>

									<div
										className="logo-details employee-details-container"
										style={{ marginTop: "0.7rem" }}
									>
										<img src={TeleConnectLogo} style={{ width: "9.5rem", height: "2rem" }} />
									</div>
								</div>
							</Grid> */}
							</Grid>
						</div>
						<div
							className="employee-details-container"
							style={{
								marginTop: "0.5rem",
								fontWeight: "Bold",
								fontSize: "0.77rem",
								display: "flex"
							}}
						>
							<span style={{ flex: 2 }}>
								Note: Possession of this identification card does not guarantee coverage
							</span>
						</div>
					</Paper>
				</div>
			</div>
			<div className="employee-id-container" id="employee-id-container">
				<div className="paper-form-container">
					<Paper className="theme-border-radius employee-print-paper-container" elevation={1}>
						<div className="summary-benefits-footer-container">
							<div className="footer-top-content-container">
								{/* <span>Precertification is required : </span>
								<span className="footer-top-sub-content" style={{ marginLeft: "4px" }}>
									Call Spectrum Services at (800) 258-5055
								</span> */}
								Dependent coverage is required for dependents to receive treatment. <br />
								Clinic patients must be 8 years and older.
							</div>
							{/* <div className="footer-top-content-container">
								Clinic patients must be 8 years and older.
							</div> */}
							<div className="footer-border" />
							<div
								className="footer-bottom-content"
								style={{
									textShadow: "0px 0.5px, 0.5px 0px, 0.1px 0.2px",
									fontSize: "0.6rem",
									marginBottom: "0.2rem"
								}}
							>
								All other services are excluded from Clinic Card portion of the Brookshire Brothers.
								ltd.
							</div>
							{/* <div className="footer-border" /> */}
							<div className="footer-top-content-container">
								Employee Health & Dental Plan would be considered the patient’s responsibility.
								{/* <br />{" "}
								Services performed outside of the specified Clinic will not be included under the Clinic
								Card portion of the Health Plan. */}
							</div>
							<div className="footer-border" />
							<Grid
								item
								xs={6}
								sm={6}
								md={6}
								lg={6}
								xl={6}
								style={{
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									marginTop: "0.3rem",
									marginBottom: "0.3rem"
								}}
							>
								<div className="header-logo-container">
									<div className="phcs-logo-container" style={{}}>
										<img src={EntiraGreenLogo} style={{ width: "7.5rem", height: "2rem" }} />
									</div>
									<div
										className="logo-details employee-details-container"
										style={{ fontSize: "0.5rem", width: "11rem", marginLeft: "-1.2rem" }}
									>
										Workplace Wellness with Community Spirit
									</div>
								</div>

								<div
									className="logo-details employee-details-container"
									style={{ marginTop: "0.7rem" }}
								>
									<img src={TeleConnectLogo} style={{ width: "10rem", height: "100%" }} />
								</div>
							</Grid>
							<div className="footer-border" />
							<div className="footer-top-content-container">
								Services performed outside of the specified Clinic will not be included under the Clinic
								Card portion of the Health Plan.
							</div>
							{/* <div
								className="footer-bottom-content"
								style={{ textShadow: "0px 0.5px, 0.5px 0px, 0.1px 0.2px", fontSize: "0.7rem" }}
							>
								Webpage address is https://member.enrollment.nexcaliber.com
							</div> */}
							<div className="footer-border" />
							<div
								className="footer-bottom-content"
								style={{
									textShadow: "0px 0.5px, 0.5px 0px, 0.1px 0.2px",
									fontSize: "0.7rem",
									marginBottom: "0.2rem",
									padding: "0.1rem"
								}}
							>
								Clinic Card Participants shall not be entitled to any other benefits under the
								Brookshire Brothers. Ltd. Employee Health and Dental Plan.
							</div>
							<div className="footer-border" style={{ marginBottom: "0.2rem" }} />
							{/* <div className="footer-bottom-content">
								Mail all claims to: Nexcaliber , PO Box 802422, Dallas, Texas 75380
							</div> */}
							<div className="footer-logo-container">
								<img src={NexcalEmployeeLogo} alt="Nexcal employee Logo" />
							</div>
							<div className="footer-bottom-content">PO Box 802422, Dallas, Texas 75380</div>
							{/* <div className="footer-content">
								Medical and Dental Benefit / Enrollment Questions and Verifications : Call Nexcaliber
								(800) 741-0185
							</div> */}
						</div>
					</Paper>
				</div>
			</div>
		</div>
	);
});

export default ClinicCardPrintV2;
